import { asFormData } from "./RequeteService";

function extraitIdPiece(id) {
    const [, requete, piece] = id.match(/(\w+)-(.*)/);
    return { requete, piece };
}

export default class PiecesService{
    constructor(axios, axiosAuth, snackbar) {
        this.axios = axios;
        this.axiosAuth = axiosAuth;
        this.snackbar = snackbar;
    }

    extraitIdPiece(id) {
        return extraitIdPiece(id);
    }

    consultationPiece(id) {
        const { requete, piece } = extraitIdPiece(id);
        return this.axios
            .get(`/api/pieces/${requete}/${piece}`).then(response => response.data);
    }

    supprimeDocumentPiece(lien) {
        lien = lien.replaceAll(";", "");
        return this.axios
            .delete(lien).then(response => response.data);
    }


    ajouteDocumentPiece(id, index, document, fichier) {
        const { requete, piece } = extraitIdPiece(id);
        return asFormData(document, [fichier], { document: "document" }).catch(error => {
            throw error;
        }).then(formData => {
            return this.axios
                .post(`/api/pieces/${requete}/${piece}/${index}`, formData)
                .then(response => response.data);
        });
    }

    transmettreDemandePiece(id, captcha, body, auth = false) {
        const axios = auth ? this.axiosAuth : this.axios;
        const prefix = auth ? "auth/" : "";

        const params=auth ? {} : {
            headers: {
                "X-Captcha": captcha.captcha,
                "X-Captcha-Text": captcha.saisie,
            },
        };

        const { requete, piece } = extraitIdPiece(id);
        return axios
            .post(`/api/pieces/${prefix}${requete}/${piece}`, body, params)
            .then(response => response.data);
    }


}
